import { z } from "zod";
/**
 * Sources (architecture §6.7, WP-062): mail from an app KitWork+ knows carries what the app's
 * headers say about it. GitHub is the only app so far; the table that recognises apps is
 * `domain/sources.ts`.
 */
export const KnownApp = z.enum(["github"]);
/** Hide an app's mail from All mail, or show it again (WP-066); the caller's own choice. */
export const SetHiddenInAllMailInput = z.object({ app: KnownApp, hidden: z.boolean() });
/** The apps the caller now keeps out of All mail. */
export const HiddenInAllMailOutput = z.object({ hiddenInAllMail: z.array(KnownApp) });
/**
 * Why GitHub sent a notification: the local part of the `<reason>@noreply.github.com` address in
 * `Cc` (GitHub's documented "Email notification headers").
 */
export const GhReason = z.enum([
    "assign",
    "author",
    "ci_activity",
    "comment",
    "manual",
    "mention",
    "push",
    "review_requested",
    "security_alert",
    "state_change",
    "subscribed",
    "team_mention",
    "your_activity",
]);
/** The GitHub groups of the inbox, in precedence order (a thread is in the first its reasons reach). */
export const GhGroup = z.enum(["needs-me", "security", "conversation", "activity", "ci"]);
/** What a GitHub notification is about. */
export const GhItem = z.enum(["pr", "issue", "discussion", "release", "commit", "other"]);
/**
 * One GitHub message's source: the repository (`owner/name`, lowercased: GitHub's names are not
 * case-sensitive), its reasons, what it is about and its number, and `X-GitHub-Severity` on
 * Dependabot alerts.
 */
export const GitHubSource = z.object({
    app: z.literal("github"),
    repo: z.string().min(1).nullable(),
    reasons: z.array(GhReason),
    item: GhItem,
    number: z.number().int().positive().nullable(),
    severity: z.string().min(1).nullable(),
});
/** A message's source (`SourceInfo`): one shape per known app. */
export const MessageSource = z.discriminatedUnion("app", [GitHubSource]);
/** A thread's source: what its newest message from an app is about. Reasons and group sit beside it. */
export const ThreadSource = z.object({
    app: KnownApp,
    repo: z.string().min(1).nullable(),
    item: GhItem,
    number: z.number().int().positive().nullable(),
});
/** The thread's GitHub fields (`foldThread`): the reasons of all its messages and the group they place it in. */
export const ThreadGitHub = z.object({
    source: ThreadSource.nullable(),
    ghReasons: z.array(GhReason),
    ghGroup: GhGroup.nullable(),
});
//# sourceMappingURL=sources.js.map